(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const elements = document.querySelectorAll("[data-az-reveal]");
  const heroSections = document.querySelectorAll("[data-az-hero]");

  if (reduceMotion) {
    elements.forEach((element) => {
      element.classList.add("az-reveal", "is-in");
    });

    heroSections.forEach((heroSection) => {
      heroSection.classList.add("is-in");
      const parallaxTarget = heroSection.querySelector("[data-az-parallax]");
      if (parallaxTarget) {
        parallaxTarget.style.setProperty("--az-parallax-y", "0px");
      }
    });

    return;
  }

  if (!("IntersectionObserver" in window)) {
    elements.forEach((element) => {
      element.classList.add("az-reveal", "is-in");
    });

    heroSections.forEach((heroSection) => {
      heroSection.classList.add("is-in");
    });
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: "0px 0px -6% 0px"
      }
    );

    elements.forEach((element) => {
      element.classList.add("az-reveal");
      observer.observe(element);
    });

    const heroObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          heroObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.3,
        rootMargin: "0px 0px -10% 0px"
      }
    );

    heroSections.forEach((heroSection) => {
      heroObserver.observe(heroSection);
    });
  }

  const parallaxItems = Array.from(heroSections)
    .map((heroSection) => ({
      container: heroSection,
      target: heroSection.querySelector("[data-az-parallax]")
    }))
    .filter((item) => item.target);

  if (!parallaxItems.length) return;

  let ticking = false;

  const updateParallax = () => {
    parallaxItems.forEach(({ container, target }) => {
      const rect = container.getBoundingClientRect();
      const viewportCenter = window.innerHeight * 0.5;
      const sectionCenter = rect.top + rect.height * 0.5;
      const normalizedOffset = (viewportCenter - sectionCenter) / Math.max(window.innerHeight, 1);
      const translateY = Math.max(-14, Math.min(14, normalizedOffset * 24));
      target.style.setProperty("--az-parallax-y", `${translateY.toFixed(2)}px`);
    });

    ticking = false;
  };

  const requestParallaxUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  window.addEventListener("scroll", requestParallaxUpdate, { passive: true });
  window.addEventListener("resize", requestParallaxUpdate);
  requestParallaxUpdate();
})();
